var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingsymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_17103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00031 0.319824C7.08127 0.319824 6.18271 0.480464 5.32895 0.797264L5.55167 1.39726C6.33531 1.10675 7.16456 0.958604 8.00031 0.959824C11.8822 0.959824 15.0403 4.1179 15.0403 7.99982C15.0403 11.8817 11.8822 15.0398 8.00031 15.0398C4.11839 15.0398 0.960312 11.8817 0.960312 7.99982C0.960927 6.96257 1.19073 5.93828 1.63328 5.00017C2.07583 4.06207 2.7202 3.23335 3.52031 2.57326V4.79982H4.16031V1.59982H0.960312V2.23982H2.92063C2.10348 2.96058 1.44901 3.84693 1.00069 4.84002C0.55236 5.83312 0.320435 6.91022 0.320312 7.99982C0.320312 12.2344 3.76575 15.6798 8.00031 15.6798C12.2349 15.6798 15.6803 12.2344 15.6803 7.99982C15.6803 3.76526 12.2349 0.319824 8.00031 0.319824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08043 10.5598H5.44043V11.1998H10.5604V10.5598H9.92043V9.46732L8.45291 7.9998L9.92043 6.53228V5.4398H10.5604V4.7998H5.44043V5.4398H6.08043V6.53228L7.54795 7.9998L6.08043 9.46732V10.5598ZM6.72043 6.26732V5.4398H9.28043V6.26732L8.00043 7.54732L6.72043 6.26732ZM8.00043 8.45228L9.28043 9.73228V10.5598H6.72043V9.73228L8.00043 8.45228ZM6.08043 12.4798H6.72043V13.1198H6.08043V12.4798ZM7.68043 12.4798H8.32043V13.1198H7.68043V12.4798ZM9.28043 12.4798H9.92043V13.1198H9.28043V12.4798Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_17103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingsymbol);
export default __webpack_public_path__ + "static/media/pendingsymbol.0ffdd0c3f41fe99b8e86504b75328157.svg";
export { ForwardRef as ReactComponent };